import { Box, Card, TableContainer } from '@mui/material';
import { Theme, styled } from '@mui/material/styles';

type StyledTableContainerType = {
  theme: Theme;
};

const customBreadcrumbs = {
  margin: '35px 0',
};

type styledFormWrapper = {
  isTablet: boolean;
  isExtraLarge: boolean;
  isPdfReport: boolean;
  theme: Theme;
};

const exportBox = {
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '30px 0',
};

const StyledTableContainer = styled(TableContainer)(({ theme }: StyledTableContainerType) => ({
  boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  borderRadius: '16px',

  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down('lg')]: {
    minWidth: '1200px',
  },
}));

const calendarBox = {
  padding: '16px',
};

const StyledSidebarWrapper = styled(Card)(({ theme }) => ({
  minWidth: '297px',
  maxWidth: '350px',
  padding: '24px',
  backgroundColor: theme.palette.background.default,
  flexBasis: '30%',
  [theme.breakpoints.down('lg')]: {
    minWidth: 'unset',
    maxWidth: '100%',
    width: '100%',
    flexBasis: '100%',
  },
}));

const StyledFormWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTablet',
})(({ theme, isTablet, isExtraLarge, isPdfReport }: styledFormWrapper) => ({
  background: theme.palette.background.default,
  width: '100%',
  padding: '24px 20px',
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  gap: (isPdfReport && isExtraLarge) || isTablet ? '10px' : '0px',
}));
const inputFiled = {
  maxWidth: '100%',
  width: '100%',
};
type StyledAssetFormHeaderBuilderTypes = {
  isTablet: boolean;
  isExtraLarge: boolean;
  isPdfReport: boolean;
  theme: Theme;
};

const StyledReportsHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTablet',
})(({ theme, isTablet, isExtraLarge, isPdfReport }: StyledAssetFormHeaderBuilderTypes) => ({
  background: theme.palette.background.default,
  width: '100%',
  padding: '24px 20px',
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: isPdfReport && isExtraLarge ? 'column' : isTablet ? 'column' : 'row',
  gap: (isPdfReport && isExtraLarge) || isTablet ? '10px' : '0px',
}));

const btnsBox = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

const filedsBox = {
  display: 'flex',

  gap: '16px',
};

export {
  StyledSidebarWrapper,
  customBreadcrumbs,
  exportBox,
  StyledTableContainer,
  calendarBox,
  StyledFormWrapper,
  inputFiled,
  StyledReportsHeader,
  btnsBox,
  filedsBox,
};
